(() => {
  'use strict';

  const drawer = document.querySelector('[data-bsb-cd]');
  if (!drawer || drawer.dataset.bsbCdInitialized) return;
  drawer.dataset.bsbCdInitialized = 'true';

  const panel = drawer.querySelector('[data-bsb-cd-panel]');
  const scrim = drawer.querySelector('[data-bsb-cd-scrim]');

  const TRIGGERS = '.bsb-nm__cart-link, .mega-menu__cart-icon, #cart-icon-bubble';
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  let opener = null;
  let scrollY = 0;
  const initialCount = parseInt(drawer.dataset.itemCount, 10);
  let lastCount = Number.isNaN(initialCount) ? null : initialCount;

  const isOpen = () => drawer.classList.contains('is-open');

  const focusables = () =>
    Array.from(panel.querySelectorAll(FOCUSABLE)).filter(
      (el) => !el.closest('[inert]') && el.getClientRects().length > 0
    );

  const lockScroll = () => {
    scrollY = window.scrollY;
    document.body.classList.add('bsb-cd-open');
    document.body.style.top = `-${scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    if (gutter > 0) document.body.style.paddingRight = `${gutter}px`;
  };

  const unlockScroll = () => {
    document.body.classList.remove('bsb-cd-open');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('padding-right');
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  };

  let pendingFinish = null;

  const cancelFinish = () => {
    if (!pendingFinish) return;
    panel.removeEventListener('transitionend', pendingFinish.onEnd);
    clearTimeout(pendingFinish.timer);
    pendingFinish = null;
  };

  const open = (triggeredBy) => {
    if (isOpen()) return;
    cancelFinish();
    if (drawer.hidden) {
      opener = triggeredBy || document.activeElement;
      lockScroll();
    }
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      const surface = drawer.querySelector('.bsb-crt');
      if (surface) surface.dispatchEvent(new CustomEvent('bsb-cart:shown'));
    });

    const closeBtn = drawer.querySelector('[data-bsb-cd-close]');
    (closeBtn || panel).focus();
  };

  const close = () => {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');

    if (opener && typeof opener.focus === 'function') opener.focus();

    const finish = () => {
      cancelFinish();
      if (isOpen() || drawer.hidden) return;
      drawer.hidden = true;
      unlockScroll();
      opener = null;
    };

    const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (motionOk && panel) {
      const onEnd = (event) => {
        if (event.target === panel) finish();
      };
      panel.addEventListener('transitionend', onEnd);
      pendingFinish = { onEnd, timer: setTimeout(finish, 400) };
    } else {
      finish();
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(TRIGGERS);
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    },
    true
  );

  if (scrim) scrim.addEventListener('click', close);

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const items = focusables();
    if (!items.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    if (!panel.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && (active === first || active === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-bsb-cd-close]')) {
      close();
      return;
    }

    const toggle = event.target.closest('.bsb-cd__pay-toggle');
    if (!toggle) return;
    const wrap = toggle.closest('[data-bsb-cd-pay]');
    if (!wrap) return;
    const body = wrap.querySelector('.bsb-cd__pay-body');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    wrap.classList.toggle('is-open', !expanded);
    if (body) {
      if (expanded) body.setAttribute('inert', '');
      else body.removeAttribute('inert');
    }
  });

  drawer.addEventListener('bsb-cart:added', (event) => {
    const row = event.detail && event.detail.rows ? event.detail.rows[0] : null;
    const scroller = drawer.querySelector('.bsb-cd__scroll');
    if (!row || !scroller) return;
    requestAnimationFrame(() => {
      const rowBox = row.getBoundingClientRect();
      const viewBox = scroller.getBoundingClientRect();
      const foot = scroller.querySelector('.bsb-cd__foot');
      const bar = drawer.querySelector('.bsb-crt__sticky.is-shown');
      const covers = [];
      if (foot && getComputedStyle(foot).position === 'sticky') covers.push(foot.getBoundingClientRect().top);
      if (bar) covers.push(bar.getBoundingClientRect().top);
      const visibleBottom = Math.min(viewBox.bottom, ...covers.filter((top) => top > viewBox.top));
      if (rowBox.top >= viewBox.top && rowBox.bottom <= visibleBottom) return;
      const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const visibleHeight = visibleBottom - viewBox.top;
      const top = scroller.scrollTop + rowBox.top - viewBox.top - (visibleHeight - rowBox.height) / 2;
      scroller.scrollTo({ top: Math.max(0, top), behavior: motionOk ? 'smooth' : 'auto' });
    });
  });

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;

    const count = typeof cart.item_count === 'number' ? cart.item_count : null;
    const grew = lastCount === null ? true : count > lastCount;
    lastCount = count;

    if (event.detail.source === 'bsb-cart') return;
    if (grew) open(null);
  });
})();
